import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import OkCancelModal from '@/shared/components/OkCancelModal';
import RelationListPicker from '@/shared/components/input/RelationListPicker';
import intlShape from '@/shared/utils/intlShape';
import messages from '../documentMessages';

export default class UpdateDocumentRelationsModal extends Component {
  state = {
    action: 'add',
    relations: [],
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  actionChanged = event => {
    const action = event.target.value;
    this.setState({
      action,
    });
  };

  isFormInvalid = () => {
    const { action, relations } = this.state;
    if (!action || !relations.length) return true;

    return false;
  };

  addRelation = relation => {
    if (relation && relation.id) {
      this.setState(state => ({
        relations: [...state.relations.filter(x => x.id !== relation.id), relation],
      }));
    }
  };

  removeRelation = relation => {
    if (relation && relation.id) {
      this.setState(state => ({
        relations: state.relations.filter(x => x.id !== relation.id),
      }));
    }
  };

  onSave = () => {
    const { action, relations } = this.state;
    const { onSave } = this.props;

    return onSave({ action, relations });
  };

  closeModal = () => {
    const { onClose } = this.props;

    this.setState(state => ({
      ...state,
      selectedTags: [],
    }));

    onClose();
  };

  render() {
    const { show, intl } = this.props;
    const { action, relations } = this.state;

    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.AddOrRemoveRelations)}
        show={show}
        onClose={this.closeModal}
        disabled={this.isFormInvalid()}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          <div>
            <div className="form-group">
              <label className="control-label col-md-3">
                <FormattedMessage {...messages.Action} />
              </label>
              <div className="col-md-9">
                <select onChange={this.actionChanged} className="form-control" value={action}>
                  <option value="add">{intl.formatMessage(messages.AddRelations)}</option>
                  <option value="remove">{intl.formatMessage(messages.RemoveRelations)}</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-md-3">
                <FormattedMessage {...messages.Relations} />
              </label>
              <div className="col-md-9">
                <RelationListPicker
                  relations={relations}
                  onAddRelation={this.addRelation}
                  onRemoveRelation={this.removeRelation}
                  disabled={false}
                />
              </div>
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
